import { useState } from 'preact/hooks';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import { ReturnShipment } from 'components/MerchantTrackingWidget/components/ReturnShipment/models/ReturnShipment.model';
import { CancelRequestModal } from '../../../CancelRequestModal';

interface CTACancelReturnProps {
  shipment: ReturnShipment;
}

export const CTACancelReturn = ({
  shipment,
}: CTACancelReturnProps): JSX.Element => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button block variant="outlined" onClick={() => setIsOpen(true)}>
        {t('RETURN_CANCEL_RETURN_CTA')}
      </Button>

      {isOpen && (
        <CancelRequestModal
          shipment={shipment}
          isModalOpen={isOpen}
          onCloseModal={() => setIsOpen(false)}
        />
      )}
    </>
  );
};
